import { cascadeElement, AddAttributes } from "elmtree";
import { UISystem } from "../../system/ui/UISystem";
const state = {
    screenLoadIn: true,
    screenDisplay: true,
};
const [screenFade, updateScreenFade] = cascadeElement("div", (elm) => {
    if (!state.screenDisplay) {
        return (elm.style.display = "none");
    }
    else {
        elm.style.display = "block";
    }
    if (state.screenLoadIn) {
        elm.classList.add("screen-in");
        elm.classList.remove("screen-out");
    }
    else {
        elm.classList.add("screen-out");
        elm.classList.remove("screen-in");
    }
});
export function GameScreenMode() {
    UISystem.appScreen.screenModes.add([
        {
            id: "game-screen",
            getElements: (component) => screenFade([
                AddAttributes({
                    id: "game-screen",
                    className: "game-screen screen-fade",
                }),
            ], component),
            async beforeUpdate() {
                state.screenLoadIn = false;
                updateScreenFade();
                state.screenDisplay = false;
                updateScreenFade();
            },
            async afterUpdate() {
                state.screenDisplay = true;
                state.screenLoadIn = true;
                updateScreenFade();
            },
            async onOut() {
                state.screenLoadIn = false;
                updateScreenFade();
            },
            async onIn() {
                state.screenDisplay = true;
                state.screenLoadIn = true;
                updateScreenFade();
            },
        },
    ]);
}
